function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Box"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.148,44.9a3.995,3.995,0,0,0-5.458-1.469l-9.751,5.629a3.964,3.964,0,0,0-2.259-1.629l-14.92-4a7.013,7.013,0,0,0-3.51-.03L20,44.719V43a1,1,0,0,0-1-1H11a1,1,0,0,0-1,1v1H3a1,1,0,0,0-1,1V59a1,1,0,0,0,1,1h7v1a1,1,0,0,0,1,1h8a1,1,0,0,0,1-1V59.618l1.286.643a7.027,7.027,0,0,0,3.13.739H39.393a7.011,7.011,0,0,0,3.5-.938l16.8-9.7A4.011,4.011,0,0,0,61.148,44.9ZM4,58V46h6V58Zm14,2H12V44h6ZM58.69,48.634l-16.8,9.7a5,5,0,0,1-2.5.67H24.416a5.027,5.027,0,0,1-2.235-.528L20,57.382v-10.6l5.734-1.434a5,5,0,0,1,2.508.021l14.92,4a2,2,0,1,1-1.035,3.863L30.2,50.034a1,1,0,0,0-.517,1.932l11.925,3.2a4.043,4.043,0,0,0,1.042.138,3.952,3.952,0,0,0,3.965-4.317l10.072-5.815a2.036,2.036,0,0,1,2.726.732A2.008,2.008,0,0,1,58.69,48.634Z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,40H55a3,3,0,0,0,3-3V5a3,3,0,0,0-3-3H23a3,3,0,0,0-3,3V37A3,3,0,0,0,23,40ZM43,4V19.234l-3.485-2.091a1,1,0,0,0-1.03,0L35,19.234V4ZM22,5a1,1,0,0,1,1-1H33V21a1,1,0,0,0,1.515.857L39,19.166l4.485,2.691A1,1,0,0,0,45,21V4H55a1,1,0,0,1,1,1V37a1,1,0,0,1-1,1H23a1,1,0,0,1-1-1Z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrders);
export default __webpack_public_path__ + "static/media/orders.d3a807ff1048b711314de3f4a9ac2f7b.svg";
export { ForwardRef as ReactComponent };